// extracted by mini-css-extract-plugin
module.exports = {"socialShare":"SocialShare_socialShare__1FoTf","socialButtons":"SocialShare_socialButtons__35G2C"};